// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__G3luV","header":"MergedInvoice_header__1v2rp"};